import { render } from "./PrizeList.vue?vue&type=template&id=4f46f95c"
import script from "./PrizeList.vue?vue&type=script&lang=js"
export * from "./PrizeList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__